module.exports = __webpack_public_path__ + "img/train-2.131a1ba8.jpg";